import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { FirestoreService } from 'src/app/services/service.index';
import * as Survey from 'survey-angular';
import * as moment from 'moment';
import { CdkNoDataRow } from '@angular/cdk/table';
@Component({
  selector: 'app-polls',
  templateUrl: './polls.component.html',
  styleUrls: ['./polls.component.css']
})
export class PollsComponent implements OnInit {

  order:any;
  user:any;
  companyId:any;
  name:any;
  datedelivery:any;
  driverId:any;
  driver:any;

  firstname:any = '';
  lastname:any = '';
  img:any = '';

  ratingStar:any = 0;
  description:any;

  ban=true;

  recall = false;

  constructor(private activatedRoute: ActivatedRoute, private afs: FirestoreService) { }



  savePoll(company:any, datos:any){

    let order = datos.order;

    let data:any = {};

    data.poll = true;

    this.afs.updateOrder(company, order, data).then(resp => {

      this.afs.createPoll(company, datos).then(res => {
        //console.log(res);
        this.ban = false;
        this.recall = true;

      });

    });



  }





  ngOnInit(): void {

    this.ban = false;


    this.activatedRoute.params.subscribe(params => {

          this.order = params.order;
          this.companyId = params.company;




          this.afs.getOrderPro(this.companyId, this.order).then(resp => {

                let res = resp.data();

                if(res.poll){

                    this.recall = true;


                }else{

                   this.ban = true;

                   this.recall = false;

                   this.datedelivery = moment(res.datedelivery).format("DD/MM/YYYY");

                    this.driverId = res.driverId;

                    this.afs.getUser(res.driverId).subscribe(resp => {


                      this.img = resp.img;

                      this.firstname = resp.firstname;
                      this.lastname = resp.lastname;

                      this.driver = resp;




                    });

                }


          });


  });





  }

  onRate($event: any) {

    this.ratingStar = $event.newValue;

    /*alert(`Old Value:${$event.oldValue},
      New Value: ${$event.newValue}`);*/
  }

  sendPoll(){


    let data:any = {};

    data.rating = this.ratingStar;
    data.description = this.description;
    data.order = this.order;
    data.companyId = this.companyId;
    data.driverId = this.driverId;
    data.dateCreated = new Date().getTime();

    //console.log(data);

    this.savePoll(this.companyId, data);


  }

}
